import { jsx as r, jsxs as w } from "react/jsx-runtime";
import m, { useState as z, useEffect as u } from "react";
import { a as S, S as h } from "../chunks/breakpoints.907eaecd.js";
import { styled as o, css as t } from "styled-components";
import { R as B, H as s } from "../chunks/Heading.2a0f9b41.js";
import { RangoButton as y, ButtonSize as C } from "./Button.js";
import { R, P as v } from "../chunks/Paragraph.60dac1f9.js";
const E = o(B).withConfig({
  displayName: "Heading",
  componentId: "sc-zpnszz-0"
})(["margin-bottom:var(--spacing-2_5x);"]), b = o(y).withConfig({
  displayName: "Button",
  componentId: "sc-zpnszz-1"
})(["margin-top:var(--spacing-5x);"]), j = o.div.withConfig({
  displayName: "Banner",
  componentId: "sc-zpnszz-2"
})(["display:flex;flex-direction:row;width:100%;padding:var(--spacing-3x);box-sizing:border-box;border-radius:var(--border-radius-md);min-height:472px;", " ", ""], ({
  contentPosition: n
}) => t`
    ${n === "TopStart" && t`
      justify-content: flex-start;
      align-items: flex-start;
    `}
    ${n === "CenterStart" && t`
      justify-content: flex-start;
      align-items: center;
    `}
    ${n === "BottomStart" && t`
      justify-content: flex-start;
      align-items: flex-end;
    `}
    ${n === "TopEnd" && t`
      justify-content: flex-end;
      align-items: flex-start;
    `}
    ${n === "CenterEnd" && t`
      justify-content: flex-end;
      align-items: center;
    `}
    ${n === "BottomEnd" && t`
      justify-content: flex-end;
      align-items: flex-end;
    `}
  `, S.md(t`
    padding: var(--spacing-5x);
    border-radius: var(--border-radius-xl);
    min-height: 480px;
  `)), H = o.div.withConfig({
  displayName: "BannerSlotContent",
  componentId: "sc-zpnszz-3"
})(["display:flex;flex-direction:column;width:fit-content;height:fit-content;"]), N = m.forwardRef(({
  contentPosition: n = "BottomStart",
  children: e,
  ...a
}, i) => /* @__PURE__ */ r(j, { contentPosition: n, ref: i, "data-testid": "rango-banner", "data-rango-component": "rango-banner", "data-is-rango": !0, ...a, children: e })), T = m.forwardRef(({
  heading: n,
  paragraph: e,
  button: a,
  headingProps: i,
  paragraphProps: g,
  buttonProps: l,
  ...c
}, p) => {
  const [f, x] = z([window.innerWidth, window.innerHeight]);
  return u(() => {
    const d = () => {
      x([window.innerWidth, window.innerHeight]);
    };
    return window.addEventListener("resize", d), () => {
      window.removeEventListener("resize", d);
    };
  }, []), /* @__PURE__ */ w(H, { ref: p, "data-rango-component": "rango-banner-slot-content", "data-is-rango": !0, ...c, children: [
    n && /* @__PURE__ */ r(E, { size: f[0] < h.md ? s.MD : s.XL, ...i, children: n }),
    e && /* @__PURE__ */ r(R, { size: v.SM, ...g, children: e }),
    a && /* @__PURE__ */ r(b, { size: C.LG, ...l, children: a })
  ] });
});
N.displayName = "RangoBanner";
T.displayName = "RangoBannerSlotContent";
const $ = {
  TopStart: "TopStart",
  CenterStart: "CenterStart",
  BottomStart: "BottomStart",
  TopEnd: "TopEnd",
  CenterEnd: "CenterEnd",
  BottomEnd: "BottomEnd"
};
Object.values($);
export {
  N as RangoBanner,
  $ as RangoBannerPosition,
  T as RangoBannerSlotContent
};
